import * as React from 'react';
import WebGLDirector from './WebGLDirector';

export default class SketchComponent extends React.Component<{size: number}, void> {

	private canvas: HTMLCanvasElement;
	private textOverlay: HTMLDivElement;

	componentDidMount () {
		const director = new WebGLDirector(this.canvas, this.props.size, this.props.size, this.textOverlay);


		director.drawScene();
	}

	render () {
		const pixelSize = this.props.size + 'px';
		const renderSize = this.props.size * 2;

		return (
			<div style={{position: 'relative', width: pixelSize, margin: 'auto'}}>
				<canvas ref={element => this.canvas = element} width={renderSize} height={renderSize} style={{width: pixelSize, height: pixelSize}} />
				<div ref={element => this.textOverlay = element} style={{position: 'absolute', top: 0, width: pixelSize, height: pixelSize}} />
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/webGL/SketchComponent.tsx